__turbopack_context__.v({
  "blogPreview1": "blogPostPreviewCard-module-scss-module__wSgA5W__blogPreview1",
  "blogPreview2": "blogPostPreviewCard-module-scss-module__wSgA5W__blogPreview2",
  "blogPreview3": "blogPostPreviewCard-module-scss-module__wSgA5W__blogPreview3",
  "category": "blogPostPreviewCard-module-scss-module__wSgA5W__category",
  "category1": "blogPostPreviewCard-module-scss-module__wSgA5W__category1",
  "excerpt": "blogPostPreviewCard-module-scss-module__wSgA5W__excerpt",
  "itemLink": "blogPostPreviewCard-module-scss-module__wSgA5W__itemLink",
  "leftCard": "blogPostPreviewCard-module-scss-module__wSgA5W__leftCard",
  "placeholder": "blogPostPreviewCard-module-scss-module__wSgA5W__placeholder",
  "readMore": "blogPostPreviewCard-module-scss-module__wSgA5W__readMore",
  "subDetails": "blogPostPreviewCard-module-scss-module__wSgA5W__subDetails",
  "summary": "blogPostPreviewCard-module-scss-module__wSgA5W__summary",
  "thumbnail": "blogPostPreviewCard-module-scss-module__wSgA5W__thumbnail",
  "thumbnailImage": "blogPostPreviewCard-module-scss-module__wSgA5W__thumbnailImage",
  "title": "blogPostPreviewCard-module-scss-module__wSgA5W__title",
  "titleLink": "blogPostPreviewCard-module-scss-module__wSgA5W__titleLink",
});
